import React, { Fragment, useEffect, useState } from 'react';
import Loader from '../../loader/Loader';
import NicheLandingPage from './NicheLandingPage';
import PageSEO from '../Common/PageSEO';
import { useLocale } from '../../localization/LocaleContext';

export default function CleanersMain() {
    const { t, locale } = useLocale();
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setLoader(true), 1000);
        return () => clearTimeout(timer);
    }, []);

    if (!loader) return <Loader />;

    return (
        <Fragment>
            <PageSEO title={t('niche.cleaners.metaTitle')} description={t('niche.cleaners.metaDescription')} path="/cleaners" locale={locale} />
            <NicheLandingPage nicheKey="cleaners" />
        </Fragment>
    );
}
